const exTokenURI = 'https://cryptologos.cc/logos/klaytn-klay-logo.svg?v=023'
const exTokenReceiver = '0x6CEe3d8c038ab74E2854C158d7B1b55544E814C8'
const exposureTime = 5000

export { exTokenURI, exTokenReceiver, exposureTime }
